import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BulkyGoodsIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4.04771 17C2.59361 17 1.3524 15.9619 1.09556 14.5312L1 14H3.03234L3.06431 14.1777C3.14927 14.6543 3.56333 15 4.04771 15H17.3281C17.8125 15 18.415 14.6543 18.5 14.1777L19.7825 6.00001L20.1601 4H23L23 6H21.8148L20.2803 14.5312C20.0234 15.9619 18.7822 17 17.3281 17H4.04771Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 18C16.4477 18 16 18.4477 16 19C16 19.5523 16.4477 20 17 20C17.5523 20 18 19.5523 18 19C18 18.4477 17.5523 18 17 18ZM20 19C20 20.6569 18.6569 22 17 22C15.3431 22 14 20.6569 14 19C14 17.3431 15.3431 16 17 16C18.6569 16 20 17.3431 20 19Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18ZM8 19C8 20.6569 6.65685 22 5 22C3.34315 22 2 20.6569 2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M18 2H4V2.74023V11.083C4 12.6914 5.30859 14 6.91699 14H15.1055C16.7139 14 18.0225 12.6914 18.0225 11.083V2.74023L18 2ZM15.1055 12.166H7.08301C6.48535 12.166 6 11.6807 6 11.083V4H10.0098V7H12V4H16.1885V11.083C16.1885 11.6807 15.7031 12.166 15.1055 12.166Z",
    fill: "currentColor"
  }));
}